// 3D Viewer Color Constants
// Note: These use 0x hex format for Three.js compatibility
// Corresponding CSS variables are in _theme.scss

export const WHITE = 0xffffff; // --color-white
export const BLACK = 0x000000; // --color-black
export const POINT_COLOR = 0x1fdb9b; // --color-map-green
export const SELECTED_POINT_COLOR = 0x0f6d4d;
export const MIDPOINT_COLOR = 0x23e7a5; // --color-gree300
export const MEASUREMENT_POINT_COLOR = 0x0a6043;
export const COORDINTATE_LINE_COLOR_X = 0xd1d8f9;
export const COORDINTATE_LINE_COLOR_Y = 0xb3f5ed;
export const ZOOM_POINT_COLOR = 0x099483; // --color-primary
export const RESTRICTED_AREA_COLOR = 0xe43f32;
export const MOUNTING_SURFACE_COLOR = 0x7e8884;
export const SOLAR_POINT_COLOR = 0xe8e9e9;
export const MARGIN_COLOR = 0x6cb0ff;
export const SELECTED_LINE_COLOR = 0xffdd79;
export const OUTLINR_COLOR = 0xfff5d4;

export const ZOOM_FACTOR = -30;

export const SOLAR_LABEL_PIXEL_OFFSET = 24;

export const VERTICAL = "vertical";
export const HORIZONTAL = "horizontal";
export const SOLAR_GROUP = "SOLAR_GROUP";
export const AREA = "AREA";
export const AVAILABLE_LOCALES = ["de", "en"];

export const MIN_SCALE = 1;
export const MAX_SCALE = 4;
export const ZOOM_SPEED = 0.1;

export const RENDERING_ORDER = {
  SOLAR_PLANE: 3,
  INNER_SOLAR_PLANE: 2,
  PANEL: 9999,
  INDIVIDUAL_PANEL: 12000,
  INDIVIDUAL_PANEL_OUTLINE: 15000,
  PANEL_TRASH: 15000,
  MEASUREMENT_PLANE: 20000,
  AUXILIARY_LINE: 25000,
  LINE: 30000,
  OUTER_POINT: 35000,
  INNER_POINT: 40000,
  MEASUREMENT_LABEL: 45000,
  MEASUREMENT_AREA_LABEL: 50000,
  MOVE_GRID: 55000,
  ZOOM_CENTER: 60000,
};

export const DEFAULT_HORIZONTAL_SPACING = 5;
export const DEFAULT_VERTICAL_SPACING = 5;
export const DEFAULT_MARGIN = 2;
export const DEFAULT_OFFSET = 5;

// Rack-mode constants for flat-roof mounting types.
// `null` (legacy in-memory) === Flush mode.
export const FIXED_TILT = "FIXED_TILT";
export const EAST_WEST  = "EAST_WEST";

// Backend-wire mounting mode enum — keep in sync with FFSolar-BE
// `ffsolar_be.models.mounting_configurations.MountingMode`.
export const MOUNTING_MODE = {
  FLUSH:      "FLUSH",
  FIXED_TILT: "FIXED_TILT",
  EAST_WEST:  "EAST_WEST",
};

// Bucket keys inside `area.mountingConfigurations` and the BE
// `mounting_configurations` payload. Mirrors the Pydantic field names.
export const MOUNTING_BUCKET = {
  [MOUNTING_MODE.FLUSH]:      "flush",
  [MOUNTING_MODE.FIXED_TILT]: "fixed_tilt",
  [MOUNTING_MODE.EAST_WEST]:  "east_west",
};

// In-memory `area.rackMode` (null|FIXED_TILT|EAST_WEST) ↔ wire `activeMountingMode`.
export function rackModeToMountingMode(rackMode) {
  return rackMode === null || rackMode === undefined ? MOUNTING_MODE.FLUSH : rackMode;
}
export function mountingModeToRackMode(mountingMode) {
  return mountingMode === MOUNTING_MODE.FLUSH ? null : mountingMode;
}

// Tilted-mode defaults.
export const DEFAULT_FIXED_TILT = 15;          // degrees — Fixed-tilt mode default
export const DEFAULT_EAST_WEST_TILT = 10;      // degrees — East-West mode default
export const DEFAULT_TILT = DEFAULT_FIXED_TILT; // backward-compat alias for useDefaultSolarValues
export const DEFAULT_PAIR_GAP  = 5;            // cm
export const DEFAULT_INTER_GAP = 0;            // cm — walking clearance between E-W pairs

// Panel physical thickness used for 3D rendering. Real PV modules are typically
// 30–40 mm thick; pick the middle of that range so the panels read as solid
// objects on the roof rather than zero-thickness planes.
export const PANEL_THICKNESS_M = 0.035;        // metres (35 mm)

// Sun altitude reference for inter-row spacing formula `H · sin(θ) / tan(α)`.
// 15° approximates the sun elevation at solar noon on the winter solstice
// (Dec 21) at central-European latitudes — see solar-flat-roof-master-ssot §5.2
// for the deliberate tradeoff vs. the spec's original 9 AM reference.
export const DEFAULT_SUN_ALTITUDE_DEC21_NOON = 15; // degrees

export const TEST_COMPANIES = [
  82, 101, 296, 345, 370, 483, 487, 563, 751, 1069, 1650, 2013, 2252, 2326,
  2416, 2614, 2615, 2630, 2766, 2963, 3009, 3016, 3085, 3556, 3903, 3981,
];

export const TECHNICAL_PICTURES_CATEGORY = {
  en: "Flight - Pictures - Technical",
  de: "Flug - Bilder - Technisch",
};

export const BLURRED_TECHNICAL_PICTURES_CATEGORY = {
  en: "Flight - Pictures - Blurred",
  de: "Flug - Bilder - Anonymisiert",
};


export const SENSOR_SIZE = {
  FILM_WIDTH: 36,
  FILM_HEIGHT: 24,
};

export const BLURRED_CATEGORY_INDEX = 'bl'

export const TEST_MANAUL_UPLOAD_PROJECTS = [97090, 84333, 84516]
